<template>
  <div ref="parallaxRef" data-test-id="parallax">
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { ParallaxElementConfig } from 'parallax-controller'

const props = defineProps<ParallaxElementConfig>()
const { parallaxRef } = useParallaxController(props)
</script>
